/**
 * UPT-2096 (P1-a, §3.4) — envoi JSON EXACT vers les routes de prototypes :
 * le serveur lit ces corps en mode strict (FAIL_ON_UNKNOWN_PROPERTIES) ;
 * `BaseApi.post/put/patch` ajouterait les champs de contexte SaaS au corps
 * (tenantId, organizationId, workspaceId, subscriptionId), ce qui donnerait
 * 400. Ici le corps envoyé est exactement `JSON.stringify(body)` ; les
 * en-têtes SaaS et le jeton viennent de `getOptions` et de l'intercepteur
 * global, comme pour les autres appels. `timeoutMs` (P1-b) : délai axios
 * facultatif (le lancement de l'analyse asynchrone en fixe un normal : le
 * serveur répond 202 sans attendre le modèle).
 */
import axios from 'axios';
import BaseApi from '@/uptk/core/api/BaseApi';
import { apiAzureUrl } from '@/uptk/core/api/contants';

export const sendExactJson = async <T>(
  method: 'POST' | 'PUT' | 'PATCH',
  path: string,
  body: unknown,
  timeoutMs?: number
): Promise<T> => {
  const options = await BaseApi.getOptions(undefined);
  const response = await axios.request<T>({
    method,
    url: apiAzureUrl() + path,
    data: JSON.stringify(body),
    headers: options.headers,
    ...(timeoutMs !== undefined ? { timeout: timeoutMs } : {}),
  });
  return response.data;
};
